import { blackColors, dangerColor } from 'assets/jss/material-dashboard-pro-react';

const donationDialogStyle = (theme) => ({
	singleCharityWrapper: {
		display: 'flex',
		alignItems: 'center',
		width: '100%',
		padding: '8px',
		borderRadius: '4px',
		transition: 'all .1s ease-in-out',
		'& > label': {
			marginRight: 0,
		},
		'& > div': {
			display: 'flex',
			alignItems: 'center',
			paddingTop: 8,
			paddingBottom: 8,
			paddingLeft: 17,
			maxWidth: 414,
			width: '100%',
			borderRadius: 8,
		},
	},
	dialogBodyWrapper: {
		width: '100%',
		margin: '24px 0 26px',
		[theme.breakpoints.down('xs')]: {
			padding: '0 10px',
		},
	},
	charitiesWrapper: {
		height: 335,
		width: '100%',
		marginLeft: 'auto',
		marginRight: 'auto',
		maxWidth: '478px',
		overflow: 'auto',
		marginBottom: 24,
		[theme.breakpoints.down('xs')]: {
			height: 'auto',
		},
	},
	charityName: {
		maxWidth: 227,
	},
	loaderWrapper: {
		display: 'flex',
		width: '100%',
		height: '100%',
		alignItems: 'center',
		justifyContent: 'center',
	},
	donationInputWrapper: {
		width: 80,
		marginRight: 8,
		marginBottom: 7,
		'& .MuiFormControl-root': {
			padding: 0,
			margin: 0,
		},
		'& .MuiInputBase-root input': {
			padding: 8,
			textAlign: 'right',
			height: 24,
		},
		'& .MuiFormHelperText-root': {
			position: 'absolute',
			top: 40,
			color: dangerColor[0],
			minWidth: 165,
		},
	},
	donationWrapper: {
		display: 'flex',
		alignItems: 'center',
		marginTop: 24,
	},
	imageWrapper: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		marginRight: 16,
		backgroundColor: 'white',
		'& img': {
			maxWidth: '100%',
			maxHeight: '100%',
		},
		'& svg': {
			color: blackColors[4],
		},
	},
	smIcon: {
		width: 72,
		height: 48,
		[theme.breakpoints.down('xs')]: {
			width: 50,
			height: 40,
			minWidth: 50,
		},
	},
	mdIcon: {
		width: 88,
		height: 56,
		[theme.breakpoints.down('xs')]: {
			width: 60,
			height: 50,
			minWidth: 60,
		},
	},
});

export default donationDialogStyle;
